import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {Town} from "../ek-models/town";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Response} from "../../_base/crud/models/response";
import {map} from "rxjs/operators";
import {ADMIN_CONFIG} from "../../../../environments/environment";
import {AbstractService} from "../../services/abstract-service.service";
import wilayaOfAlgeria from '../../../../assets/JSON/Wilaya_Of_Algeria.json';
import {AbstractControl, ValidatorFn} from "@angular/forms";

export interface Wilaya {
    name: string;
    value: string;
    id: string;
    code?: string;
    ar_name?: string;
    longitude?: string;
    latitude?: string
}

const wilayaList = wilayaOfAlgeria;

@Injectable({
    providedIn: 'root'
})
export class WilayaService extends AbstractService<any> {


    url: string;

    constructor(protected http: HttpClient) {
        super(http);
        this.url = `${ADMIN_CONFIG.apiEndpoint}town`;

    }

    public getWilayasItems(): Wilaya[] {
        return wilayaList;
    }

    public getTownsByWilayaId(wilayaId: number): Observable<Town[]> {
        const options = {
            params: new HttpParams()
                .append('wilayaId', wilayaId.toString())
        };
        const url = `${this.url}/wilaya`;
        return this.http.get<Response<Town[]>>(url, options).pipe(
            map((response: Response<Town[]>) => {
                if (response.body) {
                    return response.body;
                } else {
                    throw new Error();
                }
            })
        );
    }
}

export function forbiddenProvinceValidator(provinces: Wilaya[]): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        if (wilayaList.length > 0) {    // below findIndex will check if control.value is equal to one of our options or not
            const index = wilayaList.findIndex(province => {
                return (new RegExp('\^' + province.value + '\$')).test(control.value);
            });
            return index < 0 ? {'forbiddenProvinces': {value: control.value}} : null;
        }
    };
}



